<template>
	<div tabindex="0" class="hide-outline">
		<main class="main-view no-top-panel">
			<div class="title" v-if="showTopPanel">	{{ $t('flaw_view.new_flaw') }}</div>
			<div class="top-box" v-if="item && showTopPanel">
				<div class="row" :style="mobile">
				<div class="field">
					<label class="label">{{ $t('flaw_view.flaw_name') }}</label>
					<div class="control">
						<input
							v-if="isOtherFlawType"
							v-model="flaw.name"
							class="input"
							:placeholder="$t('flaw_view.enter_flaw_name_placeholder')"
						/>
						<input
							v-else
							v-model="flaw.name"
							class="input"
							disabled
						/>
					</div>
				</div>
			

				
				</div>

        <div class="row" :style="mobile">
        	<div class="field">
						<label class="label">{{ $t('flaw_view.flaw_category') }}</label>
						<div class="control">
							<div class="select is-fullwidth">
								<select v-model="selectedCategoryId">
									<option disabled value="">{{ $t('flaw_view.flaw_category_placeholder') }}</option>
									<option v-for="category in flawCategories" :key="category.id" :value="category.id">
										{{ category.translationKeyTranslated }}
									</option>
								</select>
							</div>
						</div>
					</div>
					<div class="field">
						<label class="label">{{ $t('flaw_view.flaw') }}</label>
						<div class="control">
							<div class="select is-fullwidth">
								<select v-model="selectedFlawTypeId" :disabled="!selectedCategoryId">
									<option disabled value="">{{ $t('flaw_view.flaw_name_placeholder') }}</option>
									<option v-for="type in filteredFlawTypes" :key="type.id" :value="type.id">
										{{ type.translationKeyTranslated }}
									</option>
								</select>
							</div>
						</div>
					</div>
        </div>
        <div class="row" :style="mobile">
          <div class="field description">
                  <label class="label">{{ $t('flaw_view.description') }}</label>
                  <div class="control">
                    <textarea
                      v-model="flaw.description"
                      class="textarea no-resize"
                      rows="2"
                      :placeholder="$t('flaw_view.enter_description_placeholder')"
                    />
                  </div>
                </div>
                
        </div>
    
				<div class="row" :style="mobile">
					<div class="field">
						<label class="label">{{ $t('flaw_view.action') }}</label>
						<div class="control">
							<input
							v-if="isOtherFlawType"
							v-model="flaw.measure"
							class="input"
							:placeholder="$t('flaw_view.enter_action_placeholder')"
							/>
							<input
							v-else
							v-model="flaw.measure"
							class="input"
							disabled
							/>
						</div>
					</div>

					<div class="checks">
						<div class="field check" :class="{ mobile: isMobile }">
							<label class="label"> {{ $t('flaw_view.fixed') }}</label>
							<div class="control">
								<switchButton v-model="isFixed" />
							</div>
						</div>
						<div class="field check" :class="{ mobile: isMobile }">
							<label class="label"> {{ $t('flaw_view.fix_all') }}</label>
							<div class="control">
								<switchButton v-model="fixAll" />
							</div>
						</div>
					</div>
				</div>
				<div class="row" :style="mobile">
					<div class="field">
						<label class="label">{{ $t('flaw_view.responsible') }}</label>
						<div class="control">
							<input
								v-model="roundData.roleName"
								class="input"
								:placeholder="$t('flaw_view.responsible_placeholder')"
								disabled
							/>
						</div>
					</div>
					<div class="field">
						<label class="label">{{ $t('flaw_view.performer') }}</label>
						<div class="control">
							<input
								v-model="getUser.email"
								class="input"
								:placeholder="$t('flaw_view.performer_placeholder')"
								disabled
							/>
						</div>
					</div>
				</div>
				<div class="row" :style="mobile">
					<div class="picture-upload" :class="{ mobile: isMobile }">
						<img v-if="imgSrc" class="image-preview" :src="imgSrc" />

						<div class="field picture">
							<div class="file has-name is-fullwidth is-dark">
								<label class="file-label">
									<input
										class="file-input"
										type="file"
										name="resume"
										accept="image/*"
                    capture="environment"
										@change="uploadImage"
									/>
									<span class="file-cta">
										<span class="file-icon">
											<i class="fas fa-upload"></i>
										</span>
										<span class="file-label">
											{{ $t('flaw_view.choose_image') }}
										</span>
									</span>
									<span class="file-name">
										{{ imageName }}
									</span>
								</label>
							</div>
						</div>
            <div class="field picture">
              <p v-if="imageError" class="help is-danger">{{ imageError }}</p>
            </div>
					</div>
					<div class="buttons" :class="{ mobile: isMobile }">
						<button class="button is-info" @click="addFlaw" :disabled="disable">
							<span class="icon is-white"><i class="fas fa-plus"/></span
							><span>{{ $t('flaw_view.add') }}</span>
						</button>
						<button class="button is-dark" @click="navigate">
							<span class="icon is-white"><i class="fas fa-backward"/></span
							><span>{{ $t('flaw_view.back') }}</span>
						</button>
						
						<button class="button" @click="continueWithFlaw" v-if="showIgnoreButton">{{ $t('flaw_view.ignore') }}</button>
					</div>
				</div>
			</div>
			<div class="list-header">
				<div class="title" style="margin-top: 30px; margin-bottom: 10px;">
					{{ item.name && showTopPanel ? $t('flaw_view.all_flaws_for', { name: item.name }) : $t('flaw_view.flaw') }}
				</div>
				<button class="button is-dark" @click="navigate" v-if="!showTopPanel">
					<span class="icon is-white"><i class="fas fa-backward"/></span
					><span>{{ $t('flaw_view.back') }}</span>
				</button>

            <section class="accordion" v-if="visibleFields && visibleFields.length" :key="item.fireProtection && item.fireProtection.inventoryType">
          <input type="checkbox" name="collapse3" id="handle3" checked />
          <h2 class="handle">
            <label class="" for="handle3">{{ $t('flaw_view.service_information') }}</label>
          </h2>
          <div class="content">
            <div class="fields-grid">
              <div
                class="field"
                v-for="field in visibleFields"
                :key="field"
                :class="{ 'textarea-full': !isInputField(field) }"
              >
                <div v-if="fieldLabels[field]" class=" white">
                  {{ $t(fieldLabels[field]) }}
                </div>
                <div class="control">
                 <textarea
                    v-if="!isInputField(field)"
                    class="textarea no-resize"
                    rows="2"
                    :value="getExtra(field)"
                    @input="onExtraInput(field, $event.target.value)"
                  ></textarea>

                  <input
                    v-else
                    class="input"
                    :type="numberFieldsLc.has(field.toLowerCase()) ? 'number' : 'text'"
                    :value="getExtra(field)"
                    @input="onExtraInput(field, $event.target.value)"
                  />
                </div>
              </div>
            </div>
           <div class="service-actions">
              <button
                :class="saveBtnClasses"
                type="button"
                @click.stop="saveServiceInfo"
              >
                {{$t('flaw_view.save')}}
              </button>
            </div>
          </div>
        </section>
			</div>
			<div class="panel-list-header">
				<div class="panel-header-item">{{ $t('flaw_view.flaw') }}</div>
				<div class="panel-header-item">{{ $t('flaw_view.description') }}</div>
				<div class="panel-header-item fixed">{{ $t('flaw_view.fixed') }}</div>
			</div>
			<div
				class="panel-list no-hover"
				v-for="flaw in comFlaws"
				:class="isDone(flaw)"
				:key="flaw.id"
				@click="openModal(flaw)"
			>
				<div class="panel-list-item">{{ flaw.name }}</div>
				<div class="panel-list-item">
					{{ flaw.description }}
				</div>
				<div class="panel-list-item fixed">
					<i
						class="far"
						:class="flaw.done ? 'fa-check-square' : 'fa-square'"
					></i>
				</div>
			</div>
			<div class="panel-list no-hover" v-if="comFlaws.length == 0">
				<p class="panel-list-item">	{{ $t('flaw_view.no_flaws') }} </p>
			</div>
			<FlawModal
				v-if="showModal"
				:flaw="selectedFlaw"
				@cancel="toggleModal"
				@setFixed="setFixed"
			/>
		</main>
	</div>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from 'vuex';
import switchButton from '@/components/switchButton';
import FlawModal from './modals/FlawModal';
import FlawService from '@/services/flaw';
import fireEquipmentService from '@/mixins/fireEquipmentService.js';
import MapItemService from '@/services/mapItem';
import { upsertPendingMapItemExtra, getPendingMapItemExtra } from '@/services/offlineMapItemExtra';
import { saveFlawTaxonomy, loadFlawTaxonomy } from '@/services/offlineFlawTaxonomy';
import { processImageFile } from '@/services/imageProcessing';
import { putOfflineFile } from '@/services/offlineFiles';


export default {
  props: {
    // Passed from AddFlawModal / RoundView
    ctx: {
      type: Object,
      default: () => ({})
    }
  },
  components: { switchButton, FlawModal },
  data: () => ({
    imageError: null,
    selectedTab: 0,
    roundData: null,
    loaded: false,
    item: { fireProtection: {inventoryType: ''} },
    flaw: {
      name: '',
      description: '',
      done: null,
      performer: '',
      responsible: '',
      fileId: null,
      flawTypeId: null
    },
    fileName: null,
     _previewUrl: null,
    isFixed: false,
    imgSrc: null,
    fixAll: false,
    selectedFlaw: null,
    showModal: false,
    newFlaw: [],
    flawCategories: [],
    selectedCategoryId: '',
    selectedFlawTypeId: '',
    preselectCategoryId: null,
    preselectCategoryKey: null,
    _preselectApplied: false,
    fieldLabels: fireEquipmentService.getFieldLabels(),
    numberFields: new Set([
      "chargeYear","revisionYear","installationYear","testPressureYear",
      "BatteryInstallationYear","BatteryRevisionYear",
      "ElectrodesInstallationYear","ElectrodesRevisionYear",
      "fusibleLinkDegrees","gasspringRevisionYear"
    ]),
    isSavingServiceInfo: false,
    saveFlash: null, 
      numberFieldsLc: new Set([
    "chargeYear","revisionYear","installationYear","testPressureYear",
    "BatteryInstallationYear","BatteryRevisionYear",
    "ElectrodesInstallationYear","ElectrodesRevisionYear",
    "fusibleLinkDegrees","gasspringRevisionYear",
    "batteryRevisionYear","batteryInstallationYear","electrodesRevisionYear",
    "electrodesInstallationYear","fusibleLinkYear","gasspringRevisionYear",
    "RevisionYear","ChargeYear","InstallationYear","TestPressureYear",
    "FusibleLinkYear","FusibleLinkDegrees","GasspringRevisionYear"
  ].map(s => String(s).toLowerCase())),
  }),
  computed: {
    ...mapGetters('roundHistoryStore', ['roundHistory', 'activeRound']),
    ...mapGetters('roundStore', ['round']),
    ...mapGetters('appStore', ['isMobile']),
    ...mapGetters('user', ['getUser']),
    ...mapGetters('mapItemStore', ['mapItem']),
    saveBtnClasses() {
      return [
        'button',
        this.isSavingServiceInfo ? 'is-loading' : '',
        this.saveFlash === 'success'
          ? 'is-success'
          : this.saveFlash === 'error'
          ? 'is-danger'
          : 'is-primary', // default color
      ];
    },
    mobile() {
      return this.isMobile ? { display: 'block' } : '';
    },
    comFlaws() {
      let list = [];
      if (this.item.flaws) list = list.concat(this.item.flaws);
      list = list.concat(this.newFlaw);
      return list.reverse();
    },
    disable() {
      return !this.flaw.name;
    },
    imageName() {
      return this.fileName || this.$t('flaw_view.no_image_selected');
    },
    showTopPanel() {
      const origin = this.ctx?.origin || 'loose';
      return origin === 'loose' || !!this.item?.id; // only hide for some “view-only” case
    },
    showIgnoreButton() {
      return this.comFlaws.length > 0 && this.comFlaws.some(x => x.done === null);
    },
    filteredFlawTypes() {
      if (!Array.isArray(this.flawCategories)) return [];
      const category = this.flawCategories.find(
        c => String(c.id) === String(this.selectedCategoryId)
      );
      return category?.relatedFlawTypes || [];
    },
    isOtherFlawType() {
      const selected = this.filteredFlawTypes.find(
        t => String(t.id) === String(this.selectedFlawTypeId)
      );
      return selected?.translationKey?.trim().toLowerCase().endsWith('other') || false;
    },
    visibleFields() {
      const type =
        this.item?.fireProtection?.inventoryType ||
        this.item?.inventoryType ||
        '';

      return fireEquipmentService.getVisibleFields(type);
    },
  },
  watch: {
    round: {
      handler(to) {
        if (this.loaded) {
          this.roundData = to;
          this.SET_ACTIVEROUND(this.roundData);
        }
      },
      deep: true
    },
    flawCategories(newCats) {
      if (Array.isArray(newCats) && newCats.length && !this._preselectApplied) {
        this.applyPreselect();
      }
    },
    selectedCategoryId() {
      this.selectedFlawTypeId = '';
      this.flaw.measure = '';
      this.flaw.name = '';
      const first = (this.filteredFlawTypes || [])[0];
      if (first) {
        this.selectedFlawTypeId = String(first.id);
        const isOther = (first.translationKey || '').trim().toLowerCase().endsWith('other');
        this.flaw.name = isOther ? '' : first.translationKeyTranslated;
        this.flaw.measure = isOther ? '' : first.suggestedActionTranslated;
      }
    },
    selectedFlawTypeId(newId) {
      const selectedType = this.filteredFlawTypes.find(
        type => String(type.id) === String(newId)
      );
      if (selectedType) {
        this.flaw.flawTypeId = selectedType.id;
        const isOther = (selectedType.translationKey || '').trim().toLowerCase().endsWith('other');
        this.flaw.name = isOther ? '' : selectedType.translationKeyTranslated;
        this.flaw.measure = isOther ? '' : selectedType.suggestedActionTranslated;
      }
    }
  },
  methods: {
    ...mapActions('roundStore', ['setRound']),
    ...mapMutations('roundHistoryStore', ['SET_ACTIVEROUND']),
    ...mapActions('mapItemStore', ['getMapItem']),

    _flashSave(state = 'success', ms = 1200) {
      this.saveFlash = state;     
      window.clearTimeout(this._saveFlashT);
      this._saveFlashT = window.setTimeout(() => {
        this.saveFlash = null;   
      }, ms);
    },


    ensureMapItemExtra() {
      if (!this.item.mapItemExtra) this.$set(this.item, 'mapItemExtra', {});
    },
    isDone(flaw) {
      return flaw.done ? 'done' : 'not-done';
    },
    isInputField(field) {
      const textFields = ["Comment"];
      return !textFields.includes(field);
    },
    addFlaw() {
      const origin = this.ctx?.origin || 'loose';
      const infoIdx = this.ctx?.infoIdx ?? this.roundData?.currentInfo ?? 0;
      const info = this.roundData?.infos?.[infoIdx];

      if (!info) return;

      // Build a NEW flaw object (don’t reuse this.flaw reference)
      const dto = {
        ...this.flaw,
        created: new Date(), 
        roundHistoryInfoId: info.id,
        performer: this.getUser.email,
        responsible: this.roundData.roleId,
      };

      if (this.isFixed) {
        dto.done = this.setDate();
        dto.doneBy = this.getUser.email;
      }

      if (origin === 'row') {
        // IMPORTANT: connect to the protection item, not mapItem
        dto.roundHistoryItemId = this.ctx?.rowItemId || this.item?.id || null;
        dto.roundHistoryInfoId = info.id;
      } else {
        const pos = this.ctx?.mapPos;
        const x = Number(pos?.[0]);
        dto.flawPositionX = Number.isFinite(x) ? Math.trunc(x + 15) : 30;
        const y = Number(pos?.[1]);
        dto.flawPositionY = Number.isFinite(y) ? Math.trunc(1000 - y - 15) : 30;
        dto.flawScale = 1;
      }

      // ✅ Emit ONLY the flaw DTO. RoundView decides where to store it.
      this.$emit('flaw-added', dto);

      // reset local form
      this.flaw = {
        name: '',
        description: '',
        done: null,
        performer: '',
        responsible: '',
        fileId: null,
        flawTypeId: null,
        file: null,
      };

      this.isFixed = false;
      this.fixAll = false;
      this.imgSrc = null;
      this.fileName = null;
    },

    navigate() {
      if (this.$route.name === 'RoundView') {
        this.$emit('goBack');
      } else {
        this.$router.push({
          name: 'RoundView',
          params: { roundId: this.roundData.id }
        });
      }
    },
    continueWithFlaw() {
      this.$emit('continueWithoutAdding', this.item);
    },
    setFixed(measure) {
      if (measure === undefined || measure === null) return;

      // Make a fresh copy so Vue/Vuex update reliably
      const roundData = JSON.parse(JSON.stringify(this.activeRound));
      const origin = this.ctx?.origin || 'loose';
      const infoIdx = this.ctx?.infoIdx ?? 0;

      const info = roundData?.infos?.[infoIdx];
      if (!info) {
        console.warn('setFixed: info not found', { infoIdx });
        return;
      }

      const now = this.setDate();
      const userEmail = this.getUser?.email;

      // Apply fields to the selected flaw object (the one opened in modal)
      const updatedFlaw = { ...(this.selectedFlaw || {}) };
      updatedFlaw.done = now;
      updatedFlaw.doneBy = userEmail;
      updatedFlaw.measure = measure;

      // --- Update the flaw inside roundData ---
      let applied = false;

      if (origin === 'row') {
        const rowIdx = this.ctx?.rowIdx;

        const item = info?.roundHistoryItems?.[rowIdx];
        if (!item) {
          console.warn('setFixed: item not found', { infoIdx, rowIdx });
          return;
        }

        const flawIndex = (item.flaws || []).findIndex(f =>
          (updatedFlaw.id && f.id === updatedFlaw.id) ||
          (updatedFlaw.clientKey && f.clientKey === updatedFlaw.clientKey)
        );

        if (flawIndex >= 0) {
          if (!Array.isArray(item.flaws)) item.flaws = [];
          item.flaws.splice(flawIndex, 1, updatedFlaw);
          applied = true;

          // Mark the item controlled when fixing any flaw on it
          item.controlled = now;
          item.userName = userEmail;
        }
      } else {
        // loose flaw lives on info.flaws
        const flawIndex = (info.flaws || []).findIndex(f =>
          (updatedFlaw.id && f.id === updatedFlaw.id) ||
          (updatedFlaw.clientKey && f.clientKey === updatedFlaw.clientKey)
        );

        if (flawIndex >= 0) {
          if (!Array.isArray(info.flaws)) info.flaws = [];
          info.flaws.splice(flawIndex, 1, updatedFlaw);
          applied = true;
        }
      }

      if (!applied) {
        // Fallback: search everywhere in this info (covers edge cases)
        for (const item of (info.roundHistoryItems || [])) {
          const idx = (item.flaws || []).findIndex(f =>
            (updatedFlaw.id && f.id === updatedFlaw.id) ||
            (updatedFlaw.clientKey && f.clientKey === updatedFlaw.clientKey)
          );
          if (idx >= 0) {
            item.flaws.splice(idx, 1, updatedFlaw);
            item.controlled = now;
            item.userName = userEmail;
            applied = true;
            break;
          }
        }

        if (!applied) {
          const idxLoose = (info.flaws || []).findIndex(f =>
            (updatedFlaw.id && f.id === updatedFlaw.id) ||
            (updatedFlaw.clientKey && f.clientKey === updatedFlaw.clientKey)
          );
          if (idxLoose >= 0) {
            info.flaws.splice(idxLoose, 1, updatedFlaw);
            applied = true;
          }
        }
      }

      if (!applied) {
        console.warn('setFixed: could not locate flaw in state', updatedFlaw);
        return;
      }

      // Persist back

      // close modal + notify parent (RoundView) to save/sync
      if (Array.isArray(this.item?.flaws)) {
        const localIdx = this.item.flaws.findIndex(f =>
          (updatedFlaw.id && f.id === updatedFlaw.id) ||
          (updatedFlaw.clientKey && f.clientKey === updatedFlaw.clientKey)
        );

        if (localIdx >= 0) {
          this.item.flaws.splice(localIdx, 1, updatedFlaw); // reactive
        }
      }



      this.SET_ACTIVEROUND(roundData);
      this.toggleModal();
      this.$emit('flaw-fixed', updatedFlaw);
    },
    async uploadImage(event) {
      const file = event?.target?.files?.[0];
      if (!file) return;

      // allow selecting same file again
      event.target.value = '';


      const MAX = 25 * 1024 * 1024;
      const sizeMb = Math.round(file.size / 1024 / 1024);
      const maxMb = Math.round(MAX / 1024 / 1024);

      if (file.size > MAX) {
        const msg = this.$t('flaw_view.image_too_large', {
          size: sizeMb,
          max: maxMb
        });

        this.imageError = msg;
        this.$toast?.error?.(msg);
        return;
      }

       this.imageError = null;


      // Clean previous preview URL
      if (this._previewUrl) {
        URL.revokeObjectURL(this._previewUrl);
        this._previewUrl = null;
      }

      try {
        this.fileName = file.name || 'photo';

        const { file: processed } = await processImageFile(file, {
          maxInputBytes: 25 * 1024 * 1024,
          maxOutputBytes: 1_500_000,
          maxDim: 1600,
          maxPixels: 40_000_000,
          preferMime: 'image/jpeg',
        });

        this._previewUrl = URL.createObjectURL(processed);
        this.imgSrc = this._previewUrl;

        // store for RoundView to upload or stash offline
       const key = await putOfflineFile({
          blob: processed,
          mime: processed.type,
          filename: processed.name || 'flaw.jpg',
          meta: { roundId: this.activeRound?.id, flawId: null } // flawId unknown yet
        });

      this.flaw.fileLocalKey = key;
      this.flaw.filePendingUpload = true;

      // IMPORTANT: do NOT keep the File in state (it will be lost anyway)
      this.flaw.file = null;
      } catch (err) {
        console.warn('uploadImage failed', err);

        // Clear any broken preview
        this.imgSrc = null;
        this.flaw.file = null;
        this.fileName = null;

        // Clear + specific messages
        if (err.code === 'INPUT_TOO_LARGE') {
          this.$toast?.error?.('Image is too large to add (max 25MB). Please take a new photo or choose a smaller one.');
          return;
        }
        if (err.code === 'TOO_MANY_PIXELS') {
          this.$toast?.error?.('This image is extremely large and cannot be processed on this device. Please take a lower-resolution photo.');
          return;
        }
        if (err.code === 'OUTPUT_TOO_LARGE') {
          this.$toast?.error?.('This image could not be compressed enough. Please take a new photo closer to the object.');
          return;
        }
        if (err.code === 'DECODE_FAILED') {
          this.$toast?.error?.('Unsupported image format on this device/browser. Please take a new photo or switch device.');
          return;
        }

        this.$toast?.error?.('Could not process this image. Please try another photo.');
      }
    },

    openModal(flaw) {
      if (!flaw.done) {
        this.selectedFlaw = flaw;
        this.showModal = true;
      }
    },
    toggleModal() {
      this.showModal = !this.showModal;
    },
    setDate() {
      let date = new Date();
      date.setHours(date.getHours() - date.getTimezoneOffset() / 60);
      return date;
    },
    async loadFlawData() {
      const language = this.$i18n.locale || 'en';

      // 1) Always try cache first so UI works instantly (and offline)
      const cached = loadFlawTaxonomy(language);
      if (cached?.categories?.length) {
        this.flawCategories = cached.categories;
      }

      // 2) If offline, stop here (don’t wipe categories to [])
      if (!navigator.onLine) {
        if (!this.flawCategories?.length) {
          // optional: show a toast if absolutely nothing cached
          this.$toast?.warning?.('Offline: flaw list not available on this device yet.');
        }
        return;
      }

      // 3) Online: fetch fresh and update cache
      try {
        const resp = await FlawService.GetFlawCategoriesWithFlawTypes(language);
        const raw = resp?.data?.data ?? resp?.data ?? resp;
        const cats = Array.isArray(raw) ? raw : (raw?.categories || []);
        this.flawCategories = cats || [];

        // persist for offline usage
        saveFlawTaxonomy(language, this.flawCategories);
      } catch (e) {
        // keep whatever we had from cache; don’t nuke it
        if (!this.flawCategories?.length) this.flawCategories = [];
      }
    },
        applyPreselect() {
      const cats = this.flawCategories || [];
      if (!cats.length) return;
      const wantId = this.preselectCategoryId ? String(this.preselectCategoryId) : '';
      let target = null;
      if (wantId) {
        target = cats.find(c => String(c.id) === wantId);
        if (!target && this.preselectCategoryKey) {
          const wantKey = this.preselectCategoryKey.startsWith('flaw.category.')
            ? this.preselectCategoryKey
            : `flaw.category.${this.preselectCategoryKey}`;
          target = cats.find(
            c => String(c.translationKey || '').toLowerCase() === wantKey.toLowerCase()
          );
        }
      } else {
        const hasOther = s => String(s || '').toLowerCase().includes('other');
        target =
          cats.find(c => hasOther(c.translationKey)) ||
          cats.find(c => hasOther(c.translationKeyTranslated));
      }
      if (!target) target = cats[0];
      if (target) {
        this.selectedCategoryId = String(target.id);
        const types = target.relatedFlawTypes || [];
        const otherType = types.find(t => String(t.translationKey || '').toLowerCase().includes('other'));
        const firstType = otherType || types[0];
        this.selectedFlawTypeId = firstType ? String(firstType.id) : '';
      }
      this._preselectApplied = true;
    },

buildServiceInfoPayload() {
  const fields = this.visibleFields || [];
  const nextExtra = {};


  const numberFields = [
    'batteryRevisionYear',
    'batteryInstallationYear',
    'electrodesRevisionYear',
    'electrodesInstallationYear',
    'revisionYear',
    'chargeYear',
    'installationYear',
    'testPressureYear',
    'fusibleLinkYear',
    'fusibleLinkDegrees',
    'gasspringRevisionYear',
     'BatteryRevisionYear',
    'BatteryInstallationYear',
    'ElectrodesRevisionYear',
    'ElectrodesInstallationYear',
    'RevisionYear',
    'ChargeYear',
    'InstallationYear',
    'TestPressureYear',
    'FusibleLinkYear',
    'FusibleLinkDegrees',
    'GasspringRevisionYear'
  ];
  fields.forEach(f => {
    // Läs värde — även om mapItemExtra inte finns
    let val = this.item?.mapItemExtra?.[f];
    console.log(val);
    // Om värdet saknas, null, undefined eller tomt sträng
    if (val === undefined || val === null || val === '') {
      val = numberFields.includes(f) ? 0 : '';
    }

    // Tvinga in värdet i objektet (Vue reaktivitet gillar detta)
    nextExtra[f] = val;
  });

  return nextExtra;
},
async saveServiceInfo() {
  if (this.isSavingServiceInfo) return;
  this.isSavingServiceInfo = true;

  try {
    this.ensureMapItemExtra();
    const nextExtra = this.buildServiceInfoPayload();

    const mapItemId = this.item.mapItemId || this.item.id;
    if (!mapItemId) throw new Error('No MapItem id available to save extra.');

    // 1) Always update local UI state first (optimistic)
    this.$set(this.item, 'mapItemExtra', nextExtra);

    // 2) Also push into activeRound so your draft_round_* captures it
    const info = this.roundData.infos[this.roundData.currentInfo];

    if (this.item.flawScale) {
      const idx = this.roundData.flawIndex - info.roundHistoryItems.length;
      if (idx >= 0 && idx < info.flaws.length) {
        this.$set(info.flaws, idx, { ...info.flaws[idx], mapItemExtra: nextExtra });
      }
    } else {
      const idx = this.roundData.flawIndex;
      if (idx >= 0 && idx < info.roundHistoryItems.length) {
        this.$set(info.roundHistoryItems, idx, { ...info.roundHistoryItems[idx], mapItemExtra: nextExtra });
      }
    }

    // IMPORTANT: tell RoundView “state changed” so it marks dirty + persists draft locally
    this.SET_ACTIVEROUND(this.roundData);
    this.$emit?.('saveState', this.roundData); // if you have this wiring; otherwise RoundView already listens to your modal events

    // 3) If offline -> queue the op in IndexedDB and exit
    if (!navigator.onLine) {
      await upsertPendingMapItemExtra({
        roundId: this.activeRound?.id,
        mapItemId,
        extra: nextExtra
      });
      this.$emit('service-info-queued');
      this._flashSave('success'); // it *did* save locally
      return;
    }

    // 4) Online -> hit server
    await MapItemService.upsertMapItemExtra(mapItemId, nextExtra);

    this._flashSave('success');
  } catch (err) {
    console.error('saveServiceInfo failed', err);
    this._flashSave('error');
  } finally {
    this.isSavingServiceInfo = false;
  }
},
  getExtra(field) {
    const extra = this.item?.mapItemExtra || {};
    if (extra[field] !== undefined) return extra[field];
    const lc = String(field).toLowerCase();
    for (const k in extra) {
      if (String(k).toLowerCase() === lc) return extra[k];
    }
    return this.numberFieldsLc.has(lc) ? null : '';
  },

  setExtra(field, val) {
    const extra = this.item.mapItemExtra || {};
    const lc = String(field).toLowerCase();
    for (const k in extra) {
      if (k !== field && String(k).toLowerCase() === lc) {
        this.$delete(extra, k);
      }
    }
    this.$set(extra, field, val);
  },

  onExtraInput(field, raw) {
    const isNum = this.numberFieldsLc.has(String(field).toLowerCase());
    const coerced = isNum
      ? (raw === '' || raw === null ? null : Number(raw))
      : raw;
    this.setExtra(field, coerced);
  },

  normalizeExtraKeys() {
    const extra = this.item?.mapItemExtra || {};
    const normalized = {};
    const fields = this.visibleFields || [];
    fields.forEach(f => {
      const v = this.getExtra(f);
      if (v !== undefined) normalized[f] = v;
    });
    for (const k in extra) {
      const already = Object.keys(normalized)
        .some(f => f.toLowerCase() === k.toLowerCase());
      if (!already) normalized[k] = extra[k];
    }
    this.$set(this.item, 'mapItemExtra', normalized);
  },


  },
 
  created() {



  const viewport = document.querySelector('meta[name="viewport"]');
  if (viewport) {
    viewport.content = 'initial-scale=1';
    viewport.content = `width=${window.innerWidth}`;
  }

  // Base round snapshot
  this.roundData = this.activeRound ? { ...this.activeRound } : null;
  if (!this.roundData || !Array.isArray(this.roundData.infos)) {
    // still allow component to render without crashing
    this.item = { fireProtection: { inventoryType: 'misc' }, mapItemExtra: {}, flaws: [] };
    this.loaded = true;
    return;
  }

  const origin = this.ctx?.origin || 'loose';
  const infoIdx = this.ctx?.infoIdx ?? this.roundData.currentInfo ?? 0;
  const info = this.roundData.infos[infoIdx];

  if (!info) {
    this.item = { fireProtection: { inventoryType: 'misc' }, mapItemExtra: {}, flaws: [] };
    this.loaded = true;
    return;
  }

  if (origin === 'row') {
    const rowItemId = this.ctx?.rowItemId;
    const item = (info?.roundHistoryItems || []).find(it => String(it.id) === String(rowItemId));
    this.item = item ? item : { fireProtection: { inventoryType: 'misc' }, mapItemExtra: {}, flaws: [] };
  } else {
    // loose flaw => FlawView does NOT need an item
    this.item = { fireProtection: { inventoryType: 'misc' }, mapItemExtra: {}, flaws: [] };
  }

  // Make sure these exist so template never crashes
  if (!this.item.mapItemExtra) this.$set(this.item, 'mapItemExtra', {});
  if (!this.item.fireProtection) this.$set(this.item, 'fireProtection', { inventoryType: 'misc' });
  if (!this.item.fireProtection.inventoryType) this.$set(this.item.fireProtection, 'inventoryType', 'misc');

  // preselect category (same as you have, but safe)
  this.preselectCategoryId =
    this.ctx?.prefCategoryId ||
    this.$route?.query?.prefCat ||
    this.item?.flawCategoryId ||
    this.item?.flawCategory?.id ||
    null;

  this.preselectCategoryKey =
    this.ctx?.prefCategoryKey ||
    this.$route?.query?.prefKey ||
    (this.item?.inventoryType ? `flaw.category.${String(this.item.inventoryType).trim()}` : '') ||
    null;

  this.loadFlawData();

  // Only fetch mapItem if we actually have one
  if (this.item?.mapItemId) {
    this.getMapItem(this.item.mapItemId).then(async () => {
      const mi = this.mapItem || {};

      if (mi.fireProtection?.inventoryType || mi.inventoryType) {
        this.$set(
          this.item.fireProtection,
          'inventoryType',
          mi.fireProtection?.inventoryType || mi.inventoryType
        );
      }

      // 1️⃣ hydrate from server first
      if (mi.mapItemExtra) {
        this.$set(this.item, 'mapItemExtra', { ...mi.mapItemExtra });
        this.normalizeExtraKeys();
      }

      // 2️⃣ THEN override with pending offline edits (if any)
      const pending = await getPendingMapItemExtra(
        this.activeRound?.id,
        this.item.mapItemId
      );

      if (pending?.extra) {
        this.$set(this.item, 'mapItemExtra', {
          ...(this.item.mapItemExtra || {}),
          ...pending.extra
        });
        this.normalizeExtraKeys();
      }
    });
  }

  this.$nextTick(() => { this.loaded = true; });
},

beforeDestroy() {
  if (this._previewUrl) {
    URL.revokeObjectURL(this._previewUrl);
    this._previewUrl = null;
  }
},

};
</script>


<style lang="scss" scoped>
@import "@/assets/colors.scss";

.top-box {
  background: $lightest-grey;
  padding: 10px 5px 10px 5px;
  display: block;
  border-radius: 2px;
  margin-bottom: 10px;
  .row {
    display: flex;
    &:not(:first-child) {
      margin-top: 12px;
    }
    .checks {
      flex: 1;
      display: flex;
      align-items: center;
      .field.check {
        &:not(.mobile) {
          .label {
            margin-bottom: 0;
          }
          margin-top: -0.5rem;
        }

        max-width: 80px;
        margin-bottom: 0;
      }
    }
  }
  .picture-upload {
    display: block;
    max-width: 400px;
    &.mobile {
      margin-left: auto;
      margin-right: 10px;
    }
    .file-name {
      background-color: white;
    }
  }
  .field {
    position: relative;
    flex: 1;
    &.name {
      flex: 1;
    }
    &.description {
      flex: 2;
    }
    margin-left: 10px;
    margin-right: 10px;
    .label {
      font-size: 12px;
    }
    /* &.check {
      display: flex;
      align-items: center;
      .checkbox {
        margin-top: 12px;
      }
      &.is-mobile .checkbox {
        margin-top: 0;
      }
    } */
    &.picture {
      margin-right: 0;
    }
  }
  .textarea,
  .input {
    background: white;
    border-radius: 2px;
  }
  .buttons {
    margin: 0;
    margin-left: auto;
    margin-right: 10px;
    &.mobile {
      margin-top: 0.75rem;
      justify-content: flex-end;
    }
    .button {
      border-radius: 2px;
      width: 110px;
    }
    &:not(.mobile) .button {
      align-self: flex-end;
    }
  }
}
.tabs.is-boxed {
  margin-bottom: 0;
}
.panel-list {
  &.done {
    background-color: #cdebcd;
    &:nth-child(odd) {
      background-color: #c3e0c3;
    }
  }
  &.not-done {
    background-color: #f0cbcb;
    cursor: pointer;
    &:nth-child(odd) {
      background-color: #e9b9b9;
    }
  }
}
.panel-header-item.fixed {
  width: 76px;
}
.panel-list-item.fixed {
  width: 90px;
  margin-right: 20px;
  text-align: center;
  &.clickable {
    pointer-events: all;
    cursor: pointer;
  }
  i {
    color: black;
  }
}
.image-preview {
  padding-left: 10px;
  margin-bottom: -6px;
}
.list-header {
  display: flex;
  margin-bottom: 0.5rem;
  justify-content: space-between;
  .button {
    border-radius: 2px;
    width: 110px;
    margin-top: 1.7rem;
  }
}

.fields-grid {
  margin-top: 10px;
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: .5rem;
}

.field.textarea-full { grid-column: 1 / -1; }
.select.is-fullwidth select { font-size: 0.9rem; }

.select.is-fullwidth select option { font-size: 0.9rem; }

.service-actions {
  display: flex;

  .button {
    border-radius: 2px;
    min-width: 150px;
  }
}
</style>
